// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const count_WIKI_REVIEW_RATINGS = ["%(count)s hodnotenie", "%(count)s hodnotenia", "%(count)s hodnoten\u00ed"];
export const WIKI_REVIEW_TITLE_SUFFIX = ": recenzie a sk\u00fasenosti";
